/** Same-locale permanent redirects for renamed resource slugs. */
export const RESOURCE_REDIRECTS: Record<string, string> = {
  "how-to-choose-shopify-plus-partner-erp-integration": "shopify-plus-migration",
  "shopify-plus-migration-guide-2026": "shopify-plus-migration",
  "how-to-choose-shopify-development-agency": "how-to-choose-a-shopify-development-agency",
  "shopify-plus-migration-masterclass": "shopify-replatforming-playbook",
  "masterclass-migracion-shopify-plus": "playbook-replatforming-shopify",
  // Ahrefs crawl 2026-09-01: URL never published, folded into the SEO playbook.
  "shopify-301-redirects": "shopify-technical-seo-playbook",
};

export function resolveResourceRedirect(slug: string): string | null {
  return RESOURCE_REDIRECTS[slug] ?? null;
}

/** Cross-language slugs redirect to the canonical page in the slug's language. */
export const ES_SLUG_TO_EN_PATH: Record<string, string> = {
  rendimiento: "/es/recursos/rendimiento",
  migracion: "/es/recursos/migracion",
  "seo-tecnico": "/es/recursos/seo-tecnico",
  "guia-optimizacion-rendimiento-shopify": "/es/recursos/guia-optimizacion-rendimiento-shopify",
  "playbook-replatforming-shopify": "/es/recursos/playbook-replatforming-shopify",
  "masterclass-migracion-shopify-plus": "/es/recursos/playbook-replatforming-shopify",
  "playbook-cro-shopify": "/es/recursos/playbook-cro-shopify",
  "migracion-woocommerce-shopify": "/es/recursos/migracion-woocommerce-shopify",
  "shopify-plus-vs-shopify": "/es/recursos/shopify-plus-vs-shopify",
  "caso-llantas-cavazos-migracion-shopify": "/es/recursos/caso-llantas-cavazos-migracion-shopify",
  "regresion-lcp-36-urls": "/es/recursos/regresion-lcp-36-urls",
  // Ahrefs crawl 2026-09-01: ES case-study slugs requested under /resources/.
  "caso-llantas-cavazos-migracion": "/es/recursos/caso-llantas-cavazos-migracion",
  "caso-mp-health-migracion-squarespace": "/es/recursos/caso-mp-health-migracion-squarespace",
  "caso-mp-health-migracion-squarespace-shopify":
    "/es/recursos/caso-mp-health-migracion-squarespace-shopify",
  "caso-self-care-is-for-everyone-crecimiento":
    "/es/recursos/caso-self-care-is-for-everyone-crecimiento",
  "caso-self-care-is-for-everyone-crecimiento-shopify":
    "/es/recursos/caso-self-care-is-for-everyone-crecimiento-shopify",
  "caso-petwell-migracion-magento": "/es/recursos/caso-petwell-migracion-magento",
  "caso-petwell-migracion-magento-shopify-plus":
    "/es/recursos/caso-petwell-migracion-magento-shopify-plus",
  "caso-fashionable-canes-seo": "/es/recursos/caso-fashionable-canes-seo",
  "caso-fashionable-canes-shopify-seo": "/es/recursos/caso-fashionable-canes-shopify-seo",
  "caso-fashionable-inc-colaboracion": "/es/recursos/caso-fashionable-inc-colaboracion",
  "caso-fashionable-inc-shopify-plus": "/es/recursos/caso-fashionable-inc-shopify-plus",
};

export const EN_SLUG_TO_ES_PATH: Record<string, string> = {
  performance: "/resources/performance",
  migration: "/resources/migration",
  "technical-seo": "/resources/technical-seo",
  "shopify-performance-optimization-guide": "/resources/shopify-performance-optimization-guide",
  "shopify-replatforming-playbook": "/resources/shopify-replatforming-playbook",
  "shopify-plus-migration-masterclass": "/resources/shopify-replatforming-playbook",
  "shopify-conversion-rate-optimization-playbook": "/resources/shopify-conversion-rate-optimization-playbook",
  "woocommerce-to-shopify-migration": "/resources/woocommerce-to-shopify-migration",
  "shopify-plus-vs-shopify": "/resources/shopify-plus-vs-shopify",
  "llantas-cavazos-shopify-migration-case-study": "/resources/llantas-cavazos-shopify-migration-case-study",
  "sitewide-lcp-regression-36-urls": "/resources/sitewide-lcp-regression-36-urls",
};

export function resolveCrossLocaleRedirect(slug: string, currentLocale: "en" | "es"): string | null {
  if (currentLocale === "en") return ES_SLUG_TO_EN_PATH[slug] ?? null;
  return EN_SLUG_TO_ES_PATH[slug] ?? null;
}
